import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default class ContentsSlider {
    constructor() {
        this.section = document.querySelector('.components-block-contents-slider');
        this.tabsDiv = this.section.querySelector('.tabs');
        this.itemsDiv = this.section.querySelector('.items');
        this.items = this.section.querySelectorAll('.components-block-contents-slider-item');

        this.ready();
    }

    ready() {
        this.items.forEach((item, key) => {
            if (key === 0) {
                item.firstElementChild.querySelector('button').dataset.active = true;
                item.firstElementChild.querySelector('button').dataset.active = true;
            }
            this.tabsDiv.querySelector('.swiper-wrapper').appendChild(item.firstElementChild);
        });

        const tabsSwiper = new Swiper(this.tabsDiv, {
            modules: [Navigation],
            grabCursor: true,
            slidesPerView: 'auto',
            allowTouchMove: true,
            freeMode: true,
            navigation: {
                nextEl: this.section.querySelector('.slider-button-next-desktop'),
                prevEl: this.section.querySelector('.slider-button-prev-desktop'),
            }
        });

        const itemsSwiper = new Swiper(this.itemsDiv, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 1,
            allowTouchMove: true,
            navigation: {
                nextEl: this.section.querySelector('.slider-button-next'),
                prevEl: this.section.querySelector('.slider-button-prev'),
            },
            breakpoints: {
                0: {
                    pagination: {
                        el: this.section.querySelector('.swiper-pagination-nav'),
                        type: 'fraction',
                    },
                },
                1024: {
                    pagination: '',
                },
            },
        });

        itemsSwiper.on('slideChange', () => {
            tabsSwiper.slideTo(itemsSwiper.activeIndex);

            this.tabsDiv.querySelectorAll('button').forEach((button) => {
                button.dataset.active = false;
            });
            this.tabsDiv.querySelectorAll('button')[itemsSwiper.activeIndex].dataset.active = true;
        });

        this.tabsDiv.querySelectorAll('button').forEach((button, key) => {
            button.addEventListener('click', () => {
                itemsSwiper.slideTo(key);
            });
        });
    }
}

if (document.querySelector('.components-block-contents-slider')) {
    new ContentsSlider();
}
